import { required } from "vuelidate/lib/validators";

export default {
  validations: {
    project: {
      name: { required },
      language: { required },
      timezone: { required },
      address: { required }
    },
    organization: { required }
  },
  computed: {},
  methods: {
    // returns error: boolean, telling if the form is in error state
    validate() {
      this.$v.$touch();
      return this.$v.$error;
    }
  }
};
